import { createAction } from '@reduxjs/toolkit'

import type { TActiveSourcePayload } from '../Sources/actions'

// tryCreateSFTPSettings
export const createSftpSettings = createAction('create_sftp_settings')
export const createSftpSettingsSuccess = createAction<TActiveSourcePayload>(
  'create_sftp_settings_success'
)
export const createSftpSettingsFailed = createAction(
  'create_sftp_settings_failed'
)

// tryCreateActiveSource
export const create = createAction('create_active_source')
export const createSuccess = createAction<TActiveSourcePayload>(
  'create_active_source_success'
)
export const createFailed = createAction('create_active_source_failed')

// tryUpdateActiveSource
export const update = createAction('update_active_source')
export const updateSuccess = createAction<TActiveSourcePayload>(
  'update_active_source_success'
)
export const updateFailed = createAction('update_active_source_failed')

// tryUploadActiveSourceFile
export const upload = createAction('upload_active_source_file')
export const uploadSuccess = createAction<TActiveSourcePayload>(
  'upload_active_source_file_success'
)
export const uploadFailed = createAction('upload_active_source_file_failed')

// tryActivateActiveSource
export const activate = createAction('activate_active_source')
export const activateSuccess = createAction<{ id: string }>(
  'activate_active_source_success'
)
export const activateFailed = createAction('activate_active_source_failed')

// tryDeleteActiveSource
export const destroy = createAction('destroy_active_source')
export const destroySuccess = createAction<{ id: string; sourceId: string }>(
  'destroy_active_source_success'
)
export const destroyFailed = createAction('destroy_active_source_failed')

// tryResetPassword
export const resetPassword = createAction('reset_sftp_password')
export const resetPasswordSuccess = createAction<TActiveSourcePayload>(
  'reset_sftp_password_success'
)
export const resetPasswordFailed = createAction('reset_sftp_password_failed')
